export const OPERATOR = {
  OR: 'OR',
  AND: 'AND',
  ANY: 'any',
  ALL: 'all'
};
